import { DATA_CACHE } from '@/lib/constants';
import { logger } from '@/lib/logger';

/**
 * Cleanup old drafts from localStorage to prevent storage bloat
 * Removes drafts older than 24 hours
 */
export function cleanupOldDrafts(): void {
  try {
    const maxAge = DATA_CACHE.DRAFT_MAX_AGE; // 24 hours
    const now = Date.now();
    const keysToRemove: string[] = [];

    // Scan all localStorage keys
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      
      // Check for draft keys (both new and legacy formats)
      if (key && (key.startsWith('draft:') || key.startsWith('draft-'))) {
        try {
          const value = localStorage.getItem(key);
          if (!value) continue;

          const draft = JSON.parse(value);
          
          // Check if draft has timestamp and is too old
          if (draft.timestamp || draft.lastModified) {
            const timestamp = draft.timestamp || draft.lastModified;
            const age = now - timestamp;
            
            if (age > maxAge) {
              keysToRemove.push(key);
            }
          }
        } catch (error) {
          // If we can't parse the draft, it's corrupted - remove it
          keysToRemove.push(key);
        }
      }
    }

    // Remove old/corrupted drafts
    keysToRemove.forEach(key => localStorage.removeItem(key));

    if (keysToRemove.length > 0) {
      logger.info(`Cleaned up ${keysToRemove.length} old draft(s)`);
    }
  } catch (error) {
    logger.error('Error cleaning up drafts:', error);
  }
}
